import Link from 'next/link';
import { Heading, Icon, Tooltip, variables } from 'politicamente-informados-ds';
import { ReactNode, useState } from 'react';
import styled, { css } from 'styled-components';
import { UrlObject } from 'url';
import MaletaButton from '../MaletaButton/MaletaButton';

interface StyledMobileMenuProps {
    $isOpen: boolean;
}

interface IMobileMenu {
    children: ReactNode;
    menus: any;
}

const MobileMenu: React.FC<IMobileMenu> = ({ children, menus }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleClick = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <>
            <MenuIcon onClick={handleClick} $isOpen={isOpen}>
                <span></span>
                <span></span>
                <span></span>
            </MenuIcon>
            <StyledMobileMenu $isOpen={isOpen}>
                <ul>
                    {menus &&
                        menus[`primary-menu`]?.map(
                            (item: {
                                id: any;
                                url: string | UrlObject;
                                target: string | (string & {}) | undefined;
                                title: string;
                            }) => {
                                return (
                                    <li key={`nav__mobile_menu_li_${item.id}`}>
                                        <Link
                                            href={item.url}
                                            target={item.target}
                                            prefetch={true}
                                            onClick={handleClick}>
                                            {item.title.toLowerCase()}
                                        </Link>
                                    </li>
                                );
                            }
                        )}

                    <MaletaButton mainMenu={false} />
                </ul>
            </StyledMobileMenu>
        </>
    );
};

export default MobileMenu;

const StyledMobileMenu = styled.div<StyledMobileMenuProps>`
    position: fixed;
    top: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    display: grid;
    align-items: center;
    justify-content: center;
    gap: 24px;
    background-color: #f1f1f1;
    color: ${variables.colors.primary70};
    transition: transform 0.3s ease;
    transform: translateX(${(props) => (props.$isOpen ? '0' : '100%')});

    ul {
        display: grid;
        gap: 24px;
        list-style: none;
        li {
            transition: opacity 300ms ease;
            text-align: center;
            font-weight: 700;
            &:hover {
                opacity: 0.5;
            }
        }
    }
`;

const MenuIcon = styled.div<StyledMobileMenuProps>`
    cursor: pointer;

    z-index: 100;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 25px;
    height: 25px;

    span {
        display: block;
        width: 100%;
        height: 3px;
        background-color: #333;
        transition: all 0.3s ease;
        transform-origin: 1px;

        &:nth-child(1) {
            ${({ $isOpen }) =>
                $isOpen &&
                css`
                    transform: rotate(45deg);
                `}
        }

        &:nth-child(2) {
            width: 70%;
            margin-left: auto;
            ${({ $isOpen }) =>
                $isOpen &&
                css`
                    opacity: 0;
                `}
        }

        &:nth-child(3) {
            ${({ $isOpen }) =>
                $isOpen &&
                css`
                    transform: rotate(-45deg);
                `}
        }
    }
    .style-dark & {
        span {
            background-color: ${(props) => (props.$isOpen ? '#333' : 'white')};
        }
    }
`;
